import { FC } from 'react';

interface Props {
    color?: string;
    margin?: string | number;
    size?: number;
    width?: string | number;
}

const Divider: FC<Props> = ({ size = 1, color = '#E0E0E0', margin = '20px 0', width = '100%' }) => (
    <div style={{ width, height: size, backgroundColor: color, margin }} />
);

export default Divider;
